import styled from 'styled-components';

/** Formulário nova/editar disciplina — alinhado a Strategy/Meta */
export const DisciplineFormNarrow = styled.div`
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: relative;
    z-index: 2;
    margin-top: 16px;

    @media (min-width: 576px) {
        margin-top: 20px;
    }

    @media (min-width: 992px) {
        margin-top: 24px;
    }
`;

/** Fieldset legado — tema escuro no formulário de disciplina */
export const DisciplineFieldsetWrap = styled.div`
    margin-top: 4px;
    margin-bottom: 8px;

    & fieldset {
        border: 1px solid rgba(242, 146, 5, 0.35) !important;
        border-radius: 12px !important;
        background: rgba(255, 255, 255, 0.04);
        padding: 16px 18px 20px !important;
        margin: 0 0 1.25rem 0 !important;
    }

    & legend {
        padding: 0 8px !important;
    }

    & legend .MuiFormHelperText-root {
        color: #f29205 !important;
        font-weight: 600;
        font-size: 14px;
    }

    & .MuiFormControlLabel-label {
        color: #e0e0e0 !important;
    }
`;

/** Textarea nativo — mesmo padrão que borracharia_major /stock-movement/new */
export const DisciplineErrorFieldWrap = styled.div`
    width: 100%;
`;

export const DisciplineErrorLabel = styled.label`
    display: block;
    color: #b0b0b0;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;

    @media (min-width: 768px) {
        font-size: 15px;
    }
`;

export const DisciplineErrorTextarea = styled.textarea`
    width: 100%;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: #ffffff;
    font-size: 14px;
    font-family: 'Nunito', Helvetica, sans-serif;
    resize: vertical;
    min-height: 100px;
    transition: all 0.3s ease;
    box-sizing: border-box;

    @media (min-width: 768px) {
        padding: 10px 14px;
        border-radius: 10px;
        font-size: 15px;
        min-height: 120px;
    }

    @media (min-width: 992px) {
        padding: 12px 16px;
        border-radius: 10px;
        font-size: 16px;
        min-height: 140px;
    }

    &:focus {
        outline: none;
        background: rgba(255, 255, 255, 0.08);
        border-color: #00d4ff;
        box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
    }

    &::placeholder {
        color: rgba(255, 255, 255, 0.4);
    }
`;
